import { isEmpty } from "lodash";

/**
 * Identifiants des produits du compte qui passent les filtres de recherche,
 * les produits désactivés rangés en fin de liste.
 *
 * Fonction pure, hors du composant : la liste doit être triée dès le premier
 * affichage et à chaque remontage, et pas seulement après la première
 * recherche. L'état initial de ListProduct et ses réapplications de filtres
 * passent donc par le même calcul.
 *
 * @param {object} PRODUCTS fiches du compte, indexées par identifiant.
 * @param {object} AVAILABLE stocks disponibles, indexés par identifiant.
 * @param {object} search searchName, searchMarque, searchType, searchRef,
 *        inStock ; absent, rien n'est filtré.
 * @returns {string[]} identifiants retenus.
 */
export function filtrerProduits(PRODUCTS, AVAILABLE, search = {}) {
    const { searchName = "", searchMarque = "", searchType = "", searchRef = "", inStock = false } = search

    const produits = PRODUCTS || {}
    let filteredList = Object.keys(produits)

    const vName = (searchName).toLowerCase()
    const vMarque = (searchMarque).toLowerCase()
    const vType = (searchType).toLowerCase()
    const vRef = (searchRef).toLowerCase()

    if (!isEmpty(searchName) ){
        filteredList = filteredList.filter( prodID => (
                produits[prodID] && produits[prodID].name.toLowerCase().includes(vName)
            )
        )
    }
    if (!isEmpty(searchMarque) ){
        filteredList = filteredList.filter( prodID => (
                produits[prodID] && produits[prodID].marque.toLowerCase().includes(vMarque)
            )
        )
    }
    if (!isEmpty(searchType) ){
        filteredList = filteredList.filter( prodID => (
                produits[prodID] && produits[prodID].product_type === vType
            )
        )
    }
    if (!isEmpty(searchRef) ){
        filteredList = filteredList.filter( prodID => (
                produits[prodID] && produits[prodID].ref.toLowerCase().includes(vRef)
            )
        )
    }
    if (inStock) {
        const stocks = Object.values(AVAILABLE || {})
        filteredList = filteredList.filter( prodID => (
            stocks.some( stock => stock.product_id === prodID && stock.quantity > 0)
        ))
    }

    // Les produits désactivés passent en fin de liste. La liste ne porte que
    // des identifiants : c'est la fiche qu'il faut interroger. Le tri est
    // stable, l'ordre du compte est conservé dans chacun des deux groupes.
    const desactive = prodID => !!(produits[prodID] && produits[prodID].is_disabled)
    filteredList.sort((a, b) => (desactive(a) === desactive(b)) ? 0 : desactive(a) ? 1 : -1);

    return filteredList
}
